// Expandable and collapsible, multiple times.

// - Must be used together with all the styling classes in expandable.scss
// - Can be used with any extra CSS (e.g. expandable_box) as long as
//   `expandTransitionInnerWrapper` element is a direct and only child of `expandTransitionOuterWrapper`,

up.compiler('.js-expandable', el => {
  const button = el.querySelector('.js-expandable__button')
  const expandTransitionOuterWrapper = el.querySelector('.js-expandable__expand_transition_outer_wrapper')
  const expandTransitionInnerWrapper = el.querySelector('.js-expandable__expand_transition_inner_wrapper')

  const expand = () => {
    button.setAttribute('aria-expanded', 'true')

    requestAnimationFrame(() => {
      expandTransitionInnerWrapper.style.display = 'block'

      requestAnimationFrame(() => {
        expandEnter()

        expandTransitionOuterWrapper.addEventListener(
          'transitionend',
          () => {
            expandAfterEnter()
          },
          { once: true }
        )
      })
    })
  }

  const collapse = () => {
    button.setAttribute('aria-expanded', 'false')

    requestAnimationFrame(() => {
      expandBeforeLeave()

      requestAnimationFrame(() => {
        expandLeave()

        expandTransitionOuterWrapper.addEventListener(
          'transitionend',
          () => {
            expandTransitionInnerWrapper.style.display = 'none'
          },
          { once: true }
        )
      })
    })
  }

  const expandEnter = () => {
    expandTransitionOuterWrapper.style.height = expandTransitionInnerWrapper.getBoundingClientRect().height + 'px'
  }

  const expandAfterEnter = () => {
    expandTransitionOuterWrapper.style.height = 'auto'
  }

  const expandBeforeLeave = () => {
    expandTransitionOuterWrapper.style.height = expandTransitionInnerWrapper.getBoundingClientRect().height + 'px'
  }

  const expandLeave = () => {
    // force repaint
    expandTransitionOuterWrapper.offsetHeight

    expandTransitionOuterWrapper.style.height = '0'
  }

  const onClick = () => {
    if (button.getAttribute('aria-expanded') === 'true') {
      collapse()
    } else {
      expand()
    }
  }

  const init = () => {
    button.addEventListener('click', onClick)

    return () => {
      button.removeEventListener('click', onClick)
    }
  }

  return init()
})
